module.exports = __webpack_public_path__ + "static/media/home_phone4.b007de6f.png";